module.exports = __webpack_public_path__ + "img/cat4.d04c4948.png";